import { handleAuthorization, handleOkResponseJson, handleBadRequest400, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export const obterProtocolosEntregaAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/ProtocoloEntrega/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarProtocoloEntregaAsync = async (saida, idUnidadeAdm, veiculo, motorista, observacao, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ saida, idUnidadeAdm, veiculo, motorista, observacao, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/ProtocoloEntrega`, requestOptions);
}

export const editarProtocoloEntregaAsync = async (id, saida, idUnidadeAdm, veiculo, motorista, observacao, itens) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, saida, idUnidadeAdm, veiculo, motorista, observacao, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/ProtocoloEntrega`, requestOptions);
}

export const baixarProtocoloEntregaAsync = async (id, saida, idUnidadeAdm, veiculo, motorista, observacao, ativo, itens) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, saida, idUnidadeAdm, veiculo, motorista, observacao, ativo, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/ProtocoloEntrega/baixar`, requestOptions);
}
export const inativarProtocoloEntregaAsync = async (id, saida, idUnidadeAdm, veiculo, motorista, observacao, ativo, justificativa, itens) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, saida, idUnidadeAdm, veiculo, motorista, observacao, ativo, justificativa, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/ProtocoloEntrega/inativar`, requestOptions);
}


export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/ProtocoloEntrega/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}
